<app-modal #wrapper class="select-account">
  <app-loading *ngIf="isLoading"></app-loading>
  @if(!isLoading) {
    <div class="select-account-section select-account-section-idle">
      Select an Account
      <div *ngIf="!isInitialLogin && !isFromUnauthorized" class="select-account-section-close" (click)="modalRef.hide()">
        <div class="responsive-flex-wrapper">
          <i class="material-symbols-outlined">close</i>
        </div>
      </div>
    </div>
    <div *ngIf="isFromUnauthorized" class="select-account-unauthorized-message">
      <p>You do not have permission to access the requested account. Please select an account you have access to.</p>
    </div>
    <div class="select-account-content">
      <ng-container *ngIf="accounts.length > 0; else noAccounts">
        <div class="select-account-content-card" *ngFor="let account of accounts" (click)="onLoginWithAccount(account)">
          <div class="select-account-content-card-image-account">
            <img
              [src]="localUrl + '/Resource/assets/clients/logo/' + account.logo"
              class="select-account-content-card-image-account-image"
            />
            <div class="select-account-content-card-image-account-account">{{ account.title }}</div>
          </div>

          <div class="select-account-content-card-last-logged-in">
            {{ loggedInDays(account) }}
            <div *ngIf="!account.isActive" class="select-account-content-card-last-logged-in-inactive-indicator">
              inactive
            </div>
            <div class="responsive-flex-wrapper" *ngIf="account.isActive">
              <i class="material-symbols-outlined">arrow_forward</i>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noAccounts>
        <div class="select-account-content-empty">
          {{ T.account_selection.no_accounts_linked | translate }}
        </div>
      </ng-template>
    </div>
    <div class="select-account-section select-account-section-action" (click)="onLogout()">Logout</div>
  }
</app-modal>
